<template>
	<div class="ExplainInformation">
		<div class="ExplainTop">
			<div class="ExplainInformation_input">
				<div class="ExplainInformation_input_left">讲解语言</div>
				<div class="ExplainInformation_input_right">
					<select v-on:change="getlangid($event)" name="releaseType" v-model="explainlanguage">
						<option value="请选择讲解语言">请选择讲解语言</option>
						<option :value="item.langid" v-for="item in langlist">{{item.langname}}</option>
					</select>
				</div>
			</div>
			<div class="ExplainInformation_input">
				<div class="ExplainInformation_input_left">讲解员性别</div>
				<div class="ExplainInformation_input_right">
					<select v-on:change="getsex($event)" name="releaseType" v-model="explaingender">
						<option value="请选择讲解员性别">请选择讲解员性别</option>
						<option value="0">不限</option>
						<option value="1">男</option>
						<option value="2">女</option>
					</select>
				</div>
			</div>
			<div class="ExplainInformation_input">
				<div class="ExplainInformation_input_left">讲解员等级</div>
				<div class="ExplainInformation_input_right">
					<select v-on:change="getgradeid($event)" name="releaseType" v-model="explaingrade">
						<option value="请选择讲解员等级">请选择讲解员等级</option>
						<option :value="item.gradeid" v-for="item in gradelist">{{item.gradename}}</option>
					</select>
				</div>
			</div>
			<div class="ExplainInformation_input" style="border: none;">
				<div class="ExplainInformation_input_left">讲解时间段</div>
				<div class="ExplainInformation_input_right">
					<select v-on:change="getperiodid($event)" name="releaseType" v-model="explaintime">
						<option value="请选择讲解时间段">请选择讲解时间段</option>
						<option :value="item.periodid" v-for="item in periodlist">{{item.name}}</option>
					</select>
				</div>
			</div>
		</div>
		<div class="ExplainBottom">
			<div class="MyInformation">请填写您的信息</div>
			<div class="ExplainInformation_input">
				<div class="ExplainInformation_input_left">姓名</div>
				<div class="ExplainInformation_input_right">
					<input v-model="name" type="type" name="" id="" value="" placeholder="请输入姓名" />
				</div>
			</div>
			<div class="ExplainInformation_input">
				<div class="ExplainInformation_input_left">联系方式</div>
				<div class="ExplainInformation_input_right">
					<input maxlength="11" v-model="phone" type="" name="" id="" value="" placeholder="请填写联系方式" />
				</div>
			</div>
		</div>
		<div class="buttom_bc" @click="Submission" v-show="showBtn">
			提交
		</div>
		<div class="appointment_success" v-show="success">
			<div class="success_center">
				<img v-if="success_img" src="../assets/success.png" />
				<img v-if="!success_img" src="../assets/buttom_x.png" />
				<p>{{success_text}}</p>
				<p v-if="success_img">请耐心等待审核</p>
				<div @click="determine">确定</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { wclient } from '../../static/wclient-mobile.js'
	export default {
		name: 'Explain',
		data() {
			return {
				success: false,
				success_img: false,
				success_text: "",
				baseUrl: "",
				clientHeight: document.documentElement.clientHeight,
				showBtn: true,
				access_token: "",
				explainlanguage: "请选择讲解语言",
				explaingender: "请选择讲解员性别",
				explaingrade: "请选择讲解员等级",
				explaintime: "请选择讲解时间段",
				name: "",
				phone: "",
				name_reg: "",
				phoneReg: "",
				explain_orderid: "",
				langlist: [],
				periodlist: [],
				gradelist: [],
				langid: "",
				sexid: "",
				gradeid: "",
				periodid: ""

			}
		},
		methods: {
			getlangid(event) {
				var that = this;
				that.langid = event.target.value;
			},
			getsex(event) {
				var that = this;
				that.sexid = event.target.value;
			},
			getgradeid(event) {
				var that = this;
				that.gradeid = event.target.value;
			},
			getperiodid(event) {
				var that = this;
				that.periodid = event.target.value;
			},
			getFocus() {    
				$("input").on("blur", function() {        
					window.scroll(0, 0);    
				});
			},
			determine() {
				var that = this;
				if(that.success_text == "预约成功") {
					that.$router.go(-1)
				} else {
					that.success = false;
				}
			},
			Submission() {
				var that = this;
				that.name_reg = /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/;
				that.phoneReg = /^1[3456789]\d{9}$/;
				if(that.explainlanguage == '请选择讲解语言') {
					that.success = true;
					that.success_img = false;
					that.success_text = '请选择讲解语言';
				} else if(that.explaingender == '请选择讲解员性别') {
					that.success = true;
					that.success_img = false;
					that.success_text = '请选择讲解员性别';
				} else if(that.explaingrade == '请选择讲解员等级') {
					that.success = true;
					that.success_img = false;
					that.success_text = '请选择讲解员等级';
				} else if(that.explaintime == '请选择讲解时间段') {
					that.success = true;
					that.success_img = false;
					that.success_text = '请选择讲解时间段';
				} else if(that.name == '') {
					that.success = true;
					that.success_img = false;
					that.success_text = '请填写您的姓名';
				} else if(!that.name_reg.test(that.name)) {
					that.success = true;
					that.success_img = false;
					that.success_text = '请输入正确的姓名';
				} else if(that.phone == '') {
					that.success = true;
					that.success_img = false;
					that.success_text = '请输入联系方式';
				} else if(!that.phoneReg.test(that.phone)) {
					that.success = true;
					that.success_img = false;
					that.success_text = '请输入正确的联系方式';
				} else {
					wclient.view.showLoading();
					wclient.crossdomain = true; // 启动跨域支持（多模块组合应用）
					wclient.ajax({
						type: "GET",
						url: that.baseUrl + '?ugi=explaintask&action=addexplaintask',
						dataType: "json",
						async: true,
						data: {
							langid: that.langid,
							gradeid: that.gradeid,
							sex: that.sexid,
							periodid: that.periodid,
							name: that.name,
							mobile: that.phone,
							orderid: that.explain_orderid
						},
						success: function(data) {
							wclient.view.hideLoading();
							if(data.code == 'A00006') {
								that.success = true;
								that.success_img = true;
								that.success_text = '预约成功';
							} else {
								that.success = true;
								that.success_img = false;
								that.success_text = data.errmsg;
							}

						}
					});
				}
			}
		},
		mounted() {
			var that = this;
			var publicUrl = window.location.hostname;
			that.explain_orderid = sessionStorage.getItem('explain_orderid');
			if(publicUrl == "localhost") {
				var baseUrl = "http://operation.xs.weapi.org/explanation/ajax";
			} else if(publicUrl == "m.xs.weapi.org") {
				var baseUrl = "http://operation.xs.weapi.org/explanation/ajax";
			} else {
				var baseUrl = "https://www.xiangshan1949.cn/explanation/ajax";
			}
			that.baseUrl = baseUrl;
			window.onresize = () => {
				if(this.clientHeight > document.documentElement.clientHeight) {
					this.showBtn = false
				} else {
					this.showBtn = true
				}

			}
			wclient.view.showLoading();
			wclient.crossdomain = true; // 启动跨域支持（多模块组合应用）
			wclient.ajax({
				type: "GET",
				url: that.baseUrl + '?ugi=explain&action=explainlanglist',
				dataType: "json",
				async: true,
				data: {

				},
				success: function(data) {
					wclient.view.hideLoading();
					if(data.code == 'A00006') {
						that.langlist = data.langlist;
					} else {
						that.success = true;
						that.success_img = false;
						that.success_text = data.errmsg;
					}

				}
			});
			wclient.ajax({
				type: "GET",
				url: that.baseUrl + '?ugi=explain&action=explaingradelist',
				dataType: "json",
				async: true,
				data: {

				},
				success: function(data) {
					wclient.view.hideLoading();
					if(data.code == 'A00006') {
						that.gradelist = data.gradelist;
					} else {
						that.success = true;
						that.success_img = false;
						that.success_text = data.errmsg;
					}

				}
			});
			wclient.ajax({
				type: "GET",
				url: that.baseUrl + '?ugi=explain&action=explainPeriodlist',
				dataType: "json",
				async: true,
				data: {

				},
				success: function(data) {
					wclient.view.hideLoading();
					if(data.code == 'A00006') {
						that.periodlist = data.periodlist;
					} else {
						that.success = true;
						that.success_img = false;
						that.success_text = data.errmsg;
					}

				}
			});
		}
	}
</script>

<style scoped>
	.ExplainInformation {
		width: 100%;
		height: 100vh;
		overflow: hidden;
		margin: 0 auto;
		-webkit-overflow-scrolling: touch;
		background: white;
	}
	
	.ExplainTop {
		width: 100%;
		border-bottom: 4px solid #ECECEC;
	}
	
	.buttom_bc {
		width: 60%;
		background: linear-gradient(255deg, rgba(228, 4, 4, 1), rgba(255, 56, 56, 1));
		line-height: 39px;
		border-radius: 48px;
		display: flex;
		-webkit-box-align: center;
		align-items: center;
		-webkit-box-pack: center;
		justify-content: center;
		color: #fff;
		font-size: 16px;
		margin: 0 auto;
		position: fixed;
		left: 50%;
		bottom: 2%;
		margin-left: -30%;
	}
	
	input::-webkit-input-placeholder {
		/* WebKit browsers */
		color: #B1B1B1;
	}
	
	input:-moz-placeholder {
		/* Mozilla Firefox 4 to 18 */
		color: #B1B1B1;
	}
	
	input::-moz-placeholder {
		/* Mozilla Firefox 19+ */
		color: #B1B1B1;
	}
	
	input::-ms-input-placeholder {
		/* Internet Explorer 10+ */
		color: #B1B1B1;
	}
	
	.appointment_success {
		width: 110%;
		height: 100%;
		background: rgba(0, 0, 0, 0.54);
		position: fixed;
		top: 0;
		left: 0;
	}
	
	.success_center {
		margin-top: 35%;
		background: white;
		width: 60%;
		margin-left: 15%;
		padding-top: 10px;
		border-radius: 10px;
	}
	
	.success_center img {
		width: 23%;
		margin-left: 39%;
		margin-top: 30px;
	}
	
	.success_center p:nth-of-type(1) {
		width: 80%;
		color: black;
		font-size: 17px;
		font-weight: 600;
		text-align: center;
		margin: 20px auto 0;
	}
	
	.success_center p:nth-of-type(2) {
		width: 100%;
		color: #A4A4A4;
		font-size: 16px;
		text-align: center;
		margin-top: 5px;
		letter-spacing: 1px;
	}
	
	.success_center div {
		width: 100%;
		line-height: 45px;
		text-align: center;
		font-weight: 600;
		color: rgba(228, 4, 4, 1);
		border-top: 1px solid #eee;
		margin-top: 25px;
	}
	
	.ExplainInformation_input {
		width: 90%;
		border-bottom: 1px solid #DBDBDB;
		margin: 0 5%;
		display: flex;
		justify-content: space-between;
		line-height: 55px;
		font-size: 16px;
	}
	
	input {
		border: none;
		outline: none;
		text-align: right;
		font-size: 16px;
	}
	
	select {
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		border: none;
		outline: none;
		font-size: 15px;
		color: #B1B1B1;
		background: white !important;
		direction: rtl;
	}
	
	select option {
		direction: ltr;
	}
	
	.ExplainBottom {
		width: 100%;
	}
	
	.MyInformation {
		width: 90%;
		margin: 20px auto 0;
		font-size: 15px;
		color: #b1b1b1;
	}
</style>


// WEBPACK FOOTER //
// src/components/Explain.vue